import {IntermediatePart} from "../../intermediatePart";

export default class ChairsShadow extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_island_chairs_shadow';
    this.partName = 'Center Island Chairs Shadow';
    this.visible = false;
  }

  load(dbFeature) {
    dbFeature.metaData["RoomLayout"] = (dbFeature.metaData["RoomLayout"] && dbFeature.metaData["RoomLayout"].filter(roomLayout => roomLayout.includes("I"))) || [];
    return super.load_(dbFeature, new ChairsShadow());
  }

  setLayers(layout) {

    const chairs = this.getParent().chairs;
    if (!chairs || (chairs.disabled || !chairs.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    const chairsType = this.getParent().getChairType();
    return [{
      propName: "Chair",
      propValue: chairsType
    }, {
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.CenterIsland.ChairsShadow;
    }
  }
}
